import {Navigate, Outlet} from "react-router-dom";
import {useContext} from "react";
import AuthContext from "../context/AuthContext";
import Loader from "./Loader";


function PasswordGuardRoute() {
    const {accessToken, user, isUserLoading} = useContext(AuthContext);

    if (isUserLoading) {
        return <div className="d-flex justify-content-center mt-5"><Loader size="default" /></div>;
    }
    
    if (!accessToken || user === null) {
        return <Navigate to="/login" replace />;
    }

    if (user?.must_change_password) {
        return <Navigate to="/force-password-change" replace />;
    }

    return <Outlet />;
}


export default PasswordGuardRoute;
